import React from 'react';
import ReactToPrint from "react-to-print";

export default class  Page4 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="react-print-none">
                                                <div className="border_subtitle">Stage two – Construct assertiveness
                                                    behaviour hierarchy
                                                </div>
                                                <p>The next stage is to construct an ‘assertive behaviour
                                                    hierarchy’. This can be used to develop short- and long-term
                                                    goals of how to improve your assertiveness skills. Using the
                                                    people/actions that you identified in your Stage One table,
                                                    complete the table below.</p>
                                                <div className="border_subtitle">Personal assertive behaviour
                                                    hierarchy
                                                </div>
                                                <p>By referring to the matrix you generated in table 1, you should
                                                    be able to highlight some instances where you could be more
                                                    assertive with different people. Below is a table where you can
                                                    list some of the most pressing areas for increasing your
                                                    assertiveness through specific activities with individuals. You
                                                    can include people or activities which you did not include in
                                                    table 1 as well. We have provided a hypothetical example to get
                                                    you started.</p>
                                            </div>
                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />
                                            <br/>
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink">
                                                    <tbody>
                                                    <tr>
                                                        <th width="5%" align="left" valign="top"
                                                            className="green_curve"></th>
                                                        <th width="45%" align="left" valign="top">Person</th>
                                                        <th width="45%" align="left" valign="top" colSpan="4"
                                                            className=" green_curve1">Activity
                                                        </th>


                                                    </tr>
                                                    <tr>
                                                        <td width="5%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">1</span>
                                                        </td>

                                                        <td width="45%" align="left" valign="center"
                                                            className="darkgreen circleBottomPadding uiheading">
                                                            <span className="subtitle-table"><p>Rob (Line Manager)</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="center"
                                                            className="darkgreen circleBottomPadding uiheading">
                                                            <span className="subtitle-table"><p>Ask for more reasonable deadlines</p></span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="lightgreen uiheading"><span
                                                            className="subtitle-table"><p>2</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                             <textarea style={{marginBottom: '3px'}}
                                                                       name="person2"
                                                                       id="person2"
                                                                       value={pageData?.person2}
                                                                       className="textareaTool"
                                                                       onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity2"
                                                                      id="activity2"
                                                                      value={pageData?.activity2}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="darkgreen uiheading"><span
                                                            className="subtitle-table"><p>3</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="person3"
                                                                      id="person3"
                                                                      value={pageData?.person3}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity3"
                                                                      id="activity3"
                                                                      value={pageData?.activity3}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="lightgreen uiheading"><span
                                                            className="subtitle-table"><p>4</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="person4"
                                                                      id="person4"
                                                                      value={pageData?.person4}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity4"
                                                                      id="activity4"
                                                                      value={pageData?.activity4}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="darkgreen uiheading"><span
                                                            className="subtitle-table"><p>5</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="person5"
                                                                      id="person5"
                                                                      value={pageData?.person5}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity5"
                                                                      id="activity5"
                                                                      value={pageData?.activity5}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="lightgreen uiheading"><span
                                                            className="subtitle-table"><p>6</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                             <textarea style={{marginBottom: '3px'}}
                                                                       name="person6"
                                                                       id="person6"
                                                                       value={pageData?.person6}
                                                                       className="textareaTool"
                                                                       onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity6"
                                                                      id="activity6"
                                                                      value={pageData?.activity6}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="darkgreen uiheading"><span
                                                            className="subtitle-table"><p>7</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="person7"
                                                                      id="person7"
                                                                      value={pageData?.person7}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity7"
                                                                      id="activity7"
                                                                      value={pageData?.activity7}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="lightgreen uiheading"><span
                                                            className="subtitle-table"><p>8</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="person8"
                                                                      id="person8"
                                                                      value={pageData?.person8}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity8"
                                                                      id="activity8"
                                                                      value={pageData?.activity8}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="darkgreen uiheading"><span
                                                            className="subtitle-table"><p>9</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="person9"
                                                                      id="person9"
                                                                      value={pageData?.person9}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity9"
                                                                      id="activity9"
                                                                      value={pageData?.activity9}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="5%" align="left" valign="center"
                                                            className="lightgreen uiheading"><span
                                                            className="subtitle-table"><p>10</p></span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="person10"
                                                                      id="person10"
                                                                      value={pageData?.person10}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                        <td width="45%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">
                                                            <textarea style={{marginBottom: '3px'}}
                                                                      name="activity10"
                                                                      id="activity10"
                                                                      value={pageData?.activity10}
                                                                      className="textareaTool"
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                            </span>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                                <div className="react-print-none">
                                                    <div className="border_subtitle">Stage three – Assertiveness
                                                        skills
                                                    </div>
                                                    <p>Now you know when and with whom you need to develop your
                                                        ‘assertiveness skills’. Here are some ways to do this:</p>
                                                    <p><span
                                                        className="subtiltereg">Use assertive body language</span><br/>
                                                        Face the other person, stand or sit straight, don’t use
                                                        dismissive gestures, be sure you have a pleasant, but
                                                        serious, facial expression, keep your voice calm and soft –
                                                        neither whine nor let your voice sound abrasive.</p>
                                                </div>


                                                <div className="left-btn"><div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                                <div className="right-btn"><div
                                                    onClick={this.props.savePageData('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div></div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}